<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-card>
      <com-finance-list ref="table" :defaultParams="defaultParams"></com-finance-list>
    </com-card>
  </com-page>
</template>

<script>
export default {
  data() {
    return {
      defaultParams: {
        status: 4
      },
      searchColumns: [
        {
          label: '合伙人名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '提现时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },

  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    },
  }
}
</script>

<style lang="scss" scoped></style>
